/*@flow*/
import isNil from 'lib/t/isNil';

export default function removeNils<T: { [key: string]: any }>(o: T): any {
  return Object.keys(o).reduce(
    (s, k) => (isNil(o[k]) ? s : { ...s, [k]: o[k] }),
    {}
  );
}
